'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Anand Maratha", href: "/anand-maratha" },
  { label: "96 Kuli Maratha Surname List", href: "/96-kuli-maratha-surname-list" },
  { label: "Anand Maratha Grooms" },
  { label: "Deokar Maratha brides" },
  { label: "Deokar Maratha groom" },
  { label: "Deokar Maratha photos" },
  { label: "Deokar Maratha Brides age" },
  { label: "Deokar Maratha bride" },
  { label: "Deokar Maratha brides list" },
  { label: "Deokar Maratha groom photos" },
  { label: "Deokar Maratha divorcee brides" },
  { label: "Deokar Maratha Brides photos" },
  { label: "Deokar Maratha divorcee Brides photos" },
  { label: "Deokar Maratha reviews" },
  { label: "Deokar Maratha login" },
  { label: "Deokar Maratha divorcee brides list" },
  { label: "Deokar Maratha groom photo" },
  { label: "Deokar Maratha divorcee brides Wikipedia" },
  { label: "Deokar Maratha groom photos download" },
  { label: "Deokar Maratha Sangvi" },
  { label: "Deokar Maratha grooms" },
];

export default function DeokarMaratha() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठा वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="deokar_maratha"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "What is the traditional attire for a Deokar Maratha groom?",
                  answer: "The foundation of the Maharashtrian Marathi groom attire is the dhoti, traditionally in white or cream with a golden border. It symbolizes purity and elegance. Some Maharashtrian grooms prefer a silk dhoti for a more regal appearance."
                },
                {
                  question: "Which site is best for Maratha marriage?",
                  answer: "MarathiVadhuVarSuchak.com is one of the most trusted Maratha Matrimony sites with thousand verified Maratha matrimonial profiles."
                },
                {
                  question: "What is the fees of Anand Maratha?",
                  answer: "MarathiVadhuVarSuchak.com is one of the most reputed Maratha Matrimony which offers affordable annual fees, which is Rs 2,000 only."
                },
                {
                  question: "What is Deokar Maratha wedding?",
                  answer: "MarathiVadhuVarSuchak.com is one of the trusted Maratha community matrimony for wedding search in Maharashtra."
                },
                {
                  question: "How to search Deokar Maratha Groom profiles online?",
                  answer: "You need to first visit MarathiVadhuVarSuchak.com for free registration. And after profile approval you can search Deokar Maratha Groom profiles online."
                },
                {
                  question: "How to get Deokar Maratha Brides list online?",
                  answer: "Visit MarathiVadhuVarSuchak.com for free registration and then after approval you can search Deokar Maratha Brides list online."
                },
                {
                  question: "How to search Deokar Maratha Groom Photos online?",
                  answer: "Visit MarathiVadhuVarSuchak.com to search Deokar Maratha Groom Photos online with full profile. But before that you need to register your profile online."
                },
                {
                  question: "Which Deokar Maratha marriage bureau is best in Maharashtra?",
                  answer: "MarathiVadhuVarSuchak.com is one of the trusted and best Deokar Maratha marriage bureau in Maharashtra."
                },
                {
                  question: "How to find Deokar Maratha Wikipedia information?",
                  answer: "No! Deokar Maratha Wikipedia page does not exist."
                },
                {
                  question: "How to get Deokar Maratha login page?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony to register free and then login anytime online after profile approval."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Deokar Maratha Matrimony"
        items={communityServices}
      />

    </div>
  );
}

